// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"374":"0c37c904","637":"92e32263","1190":"0c37c904","2616":"0c37c904","5322":"0c37c904","6419":"0c37c904","8235":"0c37c904"}[chunkId] + ".chunk.css";
};